import { render, staticRenderFns } from "./TimeScrroll.vue?vue&type=template&id=70ab6114&scoped=true&"
import script from "./TimeScrroll.vue?vue&type=script&lang=js&"
export * from "./TimeScrroll.vue?vue&type=script&lang=js&"
import style0 from "./TimeScrroll.vue?vue&type=style&index=0&id=70ab6114&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ab6114",
  null
  
)

export default component.exports